/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum SyncStatus {
    Pending = 'Pending',
    IsSyncing = 'IsSyncing',
    Synced = 'Synced',
    SyncedWithErrors = 'SyncedWithErrors',
    Failed = 'Failed'
  }

    export const SyncStatusTranslocoMap: Record<SyncStatus, string> = {
    [SyncStatus.Pending]: 'syncStatus.pending',
    [SyncStatus.IsSyncing]: 'syncStatus.isSyncing',
    [SyncStatus.Synced]: 'syncStatus.synced',
    [SyncStatus.SyncedWithErrors]: 'syncStatus.syncedWithErrors',
    [SyncStatus.Failed]: 'syncStatus.failed',
    };

    export const SyncStatusOptions = [
  { value: SyncStatus.Pending, labelKey: 'syncStatus.pending' },
  { value: SyncStatus.IsSyncing, labelKey: 'syncStatus.isSyncing' },
  { value: SyncStatus.Synced, labelKey: 'syncStatus.synced' },
  { value: SyncStatus.SyncedWithErrors, labelKey: 'syncStatus.syncedWithErrors' },
  { value: SyncStatus.Failed, labelKey: 'syncStatus.failed' },
    ];

